import { Backdrop, Box, CircularProgress, Typography } from '@mui/material';
import theme from 'theme';

function Loading(props){
  return(
    <Backdrop
      open={props.open ?? true}
      sx={{
        zIndex: 2000,
        backgroundColor: '#ffffff80',
      }}
    >
      <Box sx={{ textAlign: 'center', display: 'block' }}>
        <CircularProgress
          sx={{ color: theme.palette.highlight.main }}
          variant='indeterminate'
          size={40}
          thickness={4}
        />
        <Typography
          variant='h6'
          color={theme.palette.highlight.main}
          display={'block'}
        >
          Carregando
        </Typography>
        <Typography display={'block'}>
          Por favor, aguarde...
        </Typography>
      </Box>
    </Backdrop>
  )
} export default Loading;